/**
 * Micro-Gratitude & Wins Tool
 *
 * Daily log of 2 tiny good things and 1 small win with anxiety tracking.
 */

import { StepFlow, saveToolEntry, loadToolEntries } from './tools-common';

export function initMicroGratitude() {
    var root = document.getElementById('micro-gratitude');
    if (!root) return;

    var flow = new StepFlow(root);
    var preAnxiety = 5;
    var postAnxiety = 3;
    var entryId = null;

    var good1 = document.getElementById('gratitude-good-1');
    var good2 = document.getElementById('gratitude-good-2');
    var win = document.getElementById('gratitude-win');
    var submitBtn = document.getElementById('gratitude-submit');

    function checkReady() {
        var hasContent = (good1.value.trim() || good2.value.trim() || win.value.trim());
        submitBtn.disabled = !hasContent;
    }

    if (good1) good1.addEventListener('input', checkReady);
    if (good2) good2.addEventListener('input', checkReady);
    if (win) win.addEventListener('input', checkReady);

    if (submitBtn) {
        submitBtn.addEventListener('click', function () {
            preAnxiety = parseInt(document.getElementById('gratitude-pre-anxiety').value, 10);

            saveToolEntry({
                tool_slug: 'micro-gratitude',
                entry_type: 'journal_entry',
                anxiety_before: preAnxiety,
                data: {
                    good_things: [good1.value.trim(), good2.value.trim()].filter(Boolean),
                    win: win.value.trim(),
                },
            }).then(function (resp) {
                if (resp && resp.data && resp.data.entry_id) {
                    entryId = resp.data.entry_id;
                }
            });

            flow.show('post');
        });
    }

    var finishBtn = document.getElementById('gratitude-finish');
    if (finishBtn) {
        finishBtn.addEventListener('click', function () {
            postAnxiety = parseInt(document.getElementById('gratitude-post-anxiety').value, 10);

            renderResult();

            if (typeof pe_mp_tools !== 'undefined' && pe_mp_tools.is_logged_in) {
                saveToolEntry({
                    tool_slug: 'micro-gratitude',
                    entry_type: 'anxiety_update',
                    anxiety_before: preAnxiety,
                    anxiety_after: postAnxiety,
                    data: {
                        good_things: [good1.value.trim(), good2.value.trim()].filter(Boolean),
                        win: win.value.trim(),
                        original_entry_id: entryId,
                    },
                }).then(function () {
                    loadTimeline();
                });
            }

            flow.show('complete');
        });
    }

    function renderResult() {
        var shiftEl = document.getElementById('gratitude-shift');
        var entriesEl = document.getElementById('gratitude-entries');
        if (!shiftEl || !entriesEl) return;

        var diff = preAnxiety - postAnxiety;
        var cls = diff > 0 ? 'down' : diff < 0 ? 'up' : 'same';
        var arrow = diff > 0 ? '↓' : diff < 0 ? '↑' : '→';
        var label = diff > 0 ? diff + ' point' + (diff > 1 ? 's' : '') + ' calmer'
            : diff < 0 ? Math.abs(diff) + ' point' + (Math.abs(diff) > 1 ? 's' : '') + ' higher'
            : 'No change';

        shiftEl.innerHTML =
            '<div class="gratitude-result__shift-visual gratitude-result__shift-visual--' + cls + '">' +
                '<div class="gratitude-result__shift-numbers">' +
                    '<span class="gratitude-result__shift-val">' + preAnxiety + '</span>' +
                    '<span class="gratitude-result__shift-arrow">' + arrow + '</span>' +
                    '<span class="gratitude-result__shift-val">' + postAnxiety + '</span>' +
                '</div>' +
                '<span class="gratitude-result__shift-label">' + label + '</span>' +
            '</div>';

        var items = [good1.value.trim(), good2.value.trim()].filter(Boolean);
        var html = '';
        if (items.length > 0) {
            html += '<div class="gratitude-result__section">';
            html += '<span class="gratitude-result__section-label">Good things</span>';
            items.forEach(function (item) {
                html += '<div class="gratitude-result__item gratitude-result__item--good">' + escapeHtml(item) + '</div>';
            });
            html += '</div>';
        }
        if (win.value.trim()) {
            html += '<div class="gratitude-result__section">';
            html += '<span class="gratitude-result__section-label">Win</span>';
            html += '<div class="gratitude-result__item gratitude-result__item--win">' + escapeHtml(win.value.trim()) + '</div>';
            html += '</div>';
        }
        entriesEl.innerHTML = html;
    }

    function renderAnxietyTrend(el, entries) {
        var reversed = entries.slice().reverse();
        var n = reversed.length;
        var W = 480, H = 170, pL = 36, pR = 14, pT = 28, pB = 28;
        var pW = W - pL - pR, pH = H - pT - pB;
        var tc = '#BBB', gc = '#EBEBEB';

        var s = '<div class="gratitude-trend__card">';
        s += '<h3 class="gratitude-trend__title">Anxiety trend</h3>';
        s += '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" class="tool-chart-svg">';

        [0, 5, 10].forEach(function (v) {
            var yy = pT + (1 - v / 10) * pH;
            s += '<line x1="' + pL + '" y1="' + yy.toFixed(1) + '" x2="' + (W - pR) + '" y2="' + yy.toFixed(1) + '" stroke="' + gc + '" stroke-width="1"/>';
            s += '<text x="' + (pL - 6) + '" y="' + (yy + 4).toFixed(1) + '" text-anchor="end" font-size="10" fill="' + tc + '" font-family="system-ui,sans-serif">' + v + '</text>';
        });

        var bPts = '', aPts = '';
        for (var i = 0; i < n; i++) {
            var x = pL + (i / Math.max(n - 1, 1)) * pW;
            var ab = parseInt(reversed[i].anxiety_before, 10) || 0;
            var aa = parseInt(reversed[i].anxiety_after, 10) || 0;
            var yb = pT + (1 - ab / 10) * pH;
            var ya = pT + (1 - aa / 10) * pH;
            bPts += (i > 0 ? ' ' : '') + x.toFixed(1) + ',' + yb.toFixed(1);
            aPts += (i > 0 ? ' ' : '') + x.toFixed(1) + ',' + ya.toFixed(1);

            var d = new Date(reversed[i].created_at.replace(' ', 'T'));
            var lbl = d.getDate() + '/' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1);
            s += '<text x="' + x.toFixed(1) + '" y="' + (H - 6) + '" text-anchor="middle" font-size="9" fill="' + tc + '" font-family="system-ui,sans-serif">' + lbl + '</text>';
        }

        var bot = (pT + pH).toFixed(1);
        var xEnd = (pL + ((n - 1) / Math.max(n - 1, 1)) * pW).toFixed(1);
        var xSt = pL.toFixed(1);

        s += '<polyline points="' + bPts + ' ' + xEnd + ',' + bot + ' ' + xSt + ',' + bot + '" fill="rgba(255,109,139,0.08)" stroke="none"/>';
        s += '<polyline points="' + bPts + '" fill="none" stroke="#FF6D8B" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="4,3"/>';
        s += '<polyline points="' + aPts + ' ' + xEnd + ',' + bot + ' ' + xSt + ',' + bot + '" fill="rgba(41,204,106,0.08)" stroke="none"/>';
        s += '<polyline points="' + aPts + '" fill="none" stroke="#29CC6A" stroke-width="2" stroke-linecap="round"/>';

        for (var j = 0; j < n; j++) {
            var xc = pL + (j / Math.max(n - 1, 1)) * pW;
            var abv = parseInt(reversed[j].anxiety_before, 10) || 0;
            var aav = parseInt(reversed[j].anxiety_after, 10) || 0;
            var ybv = pT + (1 - abv / 10) * pH;
            var yav = pT + (1 - aav / 10) * pH;
            s += '<circle cx="' + xc.toFixed(1) + '" cy="' + ybv.toFixed(1) + '" r="3" fill="#fff" stroke="#FF6D8B" stroke-width="1.5"/>';
            s += '<circle cx="' + xc.toFixed(1) + '" cy="' + yav.toFixed(1) + '" r="3" fill="#fff" stroke="#29CC6A" stroke-width="1.5"/>';
        }

        s += '</svg>';
        s += '<div class="gratitude-trend__legend">';
        s += '<span class="gratitude-trend__legend-item"><span style="color:#FF6D8B">– –</span> before</span>';
        s += '<span class="gratitude-trend__legend-item"><span style="color:#29CC6A">—</span> after</span>';
        s += '</div>';
        s += '</div>';

        el.innerHTML = s;
    }

    function loadTimeline() {
        var container = document.getElementById('gratitude-timeline');
        var trendContainer = document.getElementById('gratitude-trend');

        loadToolEntries('micro-gratitude', 20).then(function (entries) {
            var filtered = entries.filter(function (e) {
                return e.entry_type === 'anxiety_update' && e.data_decoded;
            });
            if (filtered.length < 1) {
                if (container) container.innerHTML = '';
                if (trendContainer) trendContainer.innerHTML = '';
                return;
            }

            if (trendContainer && filtered.length >= 2) {
                renderAnxietyTrend(trendContainer, filtered);
            }

            if (!container) return;

            var html = '<h3 class="gratitude-timeline__title">Your journal</h3>';
            html += '<div class="gratitude-timeline__list">';

            filtered.forEach(function (entry) {
                var d = entry.data_decoded || {};
                var items = d.good_things || [];
                var w = d.win || '';
                var ab = entry.anxiety_before !== null ? parseInt(entry.anxiety_before, 10) : null;
                var aa = entry.anxiety_after !== null ? parseInt(entry.anxiety_after, 10) : null;
                var date = formatDate(entry.created_at);

                var diff = (ab !== null && aa !== null) ? ab - aa : 0;
                var shiftCls = diff > 0 ? 'down' : diff < 0 ? 'up' : 'same';
                var shiftTxt = diff > 0 ? '−' + diff : diff < 0 ? '+' + Math.abs(diff) : '0';

                html += '<div class="gratitude-timeline__entry">';
                html += '<div class="gratitude-timeline__dot"></div>';
                html += '<div class="gratitude-timeline__content">';
                html += '<div class="gratitude-timeline__header">';
                html += '<span class="gratitude-timeline__date">' + date + '</span>';
                if (ab !== null && aa !== null) {
                    html += '<span class="gratitude-timeline__badge gratitude-timeline__badge--' + shiftCls + '">' + shiftTxt + '</span>';
                }
                html += '</div>';

                if (items.length > 0) {
                    items.forEach(function (item) {
                        html += '<p class="gratitude-timeline__item">✦ ' + escapeHtml(item) + '</p>';
                    });
                }
                if (w) {
                    html += '<p class="gratitude-timeline__item gratitude-timeline__item--win">★ ' + escapeHtml(w) + '</p>';
                }
                html += '</div></div>';
            });

            html += '</div>';
            container.innerHTML = html;
        });
    }

    root.querySelectorAll('.tool-restart-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (good1) good1.value = '';
            if (good2) good2.value = '';
            if (win) win.value = '';
            if (submitBtn) submitBtn.disabled = true;
            entryId = null;
            var tl = document.getElementById('gratitude-timeline');
            if (tl) tl.innerHTML = '';
            var tr = document.getElementById('gratitude-trend');
            if (tr) tr.innerHTML = '';
            flow.reset();
        });
    });
}

function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr.replace(' ', 'T'));
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var day = d.getDate();
    var month = months[d.getMonth()];
    var h = d.getHours();
    var m = d.getMinutes();
    return day + ' ' + month + ', ' + (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
}
